export default __webpack_public_path__ + "static/media/news-icon-colored.54a2661a.svg";